import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import { API_METHOD_DELETE, API_DELETE_TASK } from '@/constants/apiConstants';

export interface DeleteTaskResponse {
  status: string;
  data?: any;
  message?: string;
}

export const deleteTaskApi = async (
  taskUuid: string,
): Promise<DeleteTaskResponse> => {
  const method: Method = API_METHOD_DELETE;
  const url = API_DELETE_TASK(taskUuid);

  console.log('Delete Task API Call Details:', { method, url });

  try {
    const response = await apiCall({ method, url });
    return response;
  } catch (error) {
    console.error('Delete Task API Call Error:', error);
    throw error;
  }
};
